import { AccelerateProcessStatus } from '../../enums';

const PreCodableStatus = new Set<keyof typeof AccelerateProcessStatus>([
  AccelerateProcessStatus.WAITING_FOR_IMPORT,
  AccelerateProcessStatus.IMPORTING,
  AccelerateProcessStatus.RETRY_IMPORT
]);

const CodableStatus = new Set<keyof typeof AccelerateProcessStatus>([
  AccelerateProcessStatus.NEW,
  AccelerateProcessStatus.IN_PROGRESS
]);

const CancelledStatus = new Set<keyof typeof AccelerateProcessStatus>([
  AccelerateProcessStatus.CANCELLED,
  AccelerateProcessStatus.WAITING_FOR_SEND,
  AccelerateProcessStatus.SENT
]);

const PostCodableStatus = new Set<keyof typeof AccelerateProcessStatus>([
  AccelerateProcessStatus.WAITING_FOR_SEND,
  AccelerateProcessStatus.SENDING,
  AccelerateProcessStatus.SENT,
  AccelerateProcessStatus.RETRY_SEND,
  AccelerateProcessStatus.SUBMITTED,
  AccelerateProcessStatus.LATE_CASE_UPDATE
]);

const NonCodableStatus = new Set<keyof typeof AccelerateProcessStatus>([
  AccelerateProcessStatus.LATE_CASE_UPDATE,
  AccelerateProcessStatus.REPLACED
]);

export {
  PreCodableStatus,
  CodableStatus,
  PostCodableStatus,
  CancelledStatus,
  NonCodableStatus
};
